import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { spring } from "../../utils/motion";
interface IconButtonProps {
  label: string;
  children: ReactNode;
  onClick?: () => void;
  to?: string;
  className?: string;
  pressed?: boolean;
}
export function IconButton({
  label,
  children,
  onClick,
  to,
  className,
  pressed
}: IconButtonProps) {
  const classes = twMerge("grid h-10 w-10 shrink-0 place-items-center rounded-xl border-3 border-line bg-surface text-ink shadow-brutal-sm outline-none focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-brand", className);
  const motionProps = {
    whileHover: {
      y: -1
    },
    whileTap: {
      x: 2,
      y: 2,
      boxShadow: "0px 0px 0 0 rgb(var(--line) / 0.85)"
    },
    transition: spring.snappy
  };
  if (to) {
    return <Link to={to} aria-label={label} title={label} className="rounded-xl" data-id="element-1191" data-mp="3ahj2fah14s45">
        <motion.span {...motionProps} className={classes} data-id="element-1192" data-mp="3qi654mjk3jct">
          {children}
        </motion.span>
      </Link>;
  }
  return <motion.button type="button" aria-label={label} aria-pressed={pressed} title={label} onClick={onClick} {...motionProps} className={classes} data-id="element-1193" data-mp="3ujrkqfnh6bqp">
      {children}
    </motion.button>;
}